import { FlexGrid, FlexGridItem } from 'baseui/flex-grid'
import { KIND, SIZE } from 'baseui/button'
import { TYPE } from 'baseui/select'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDSelect from '@/shared/components/SDComponents/SDSelect/SDSelect'
import { Card, Header1 } from '@/shared/theme/styled-components'
import OptInSmsModal from './OptInSmsModal/OptInSmsModal'
import useHeading from './useHeading'

const Heading = () => {
  const {
    t,
    css,
    providerGeneral,
    selectedProvider,
    selectedItem,
    handleSelectProvider,
    handleEdit,
    handleDelete,
    handleAddOffer,
    handleNetting,
    handleAddProvider,
    handleOptInSms,
    isOptInSmsAvailable,
  } = useHeading()

  const itemProps = {
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
  }

  return (
    <Card>
      <Header1>{t('organizationManagement:header_title')}</Header1>
      <FlexGrid flexGridColumnCount={3} flexGridColumnGap='scale800' flexGridRowGap='scale800' marginBottom='scale800'>
        <FlexGridItem {...itemProps}>
          <SDSelect
            type={TYPE.search}
            options={providerGeneral.providersList}
            value={selectedItem()}
            onChange={handleSelectProvider}
          />
        </FlexGridItem>
        <FlexGridItem {...itemProps}>
          {selectedProvider.uuid && (
            <>
              <SDButton
                onClick={handleEdit}
                size={SIZE.mini}
                kind={KIND.secondary}
                className={css({
                  marginRight: '10px',
                })}
              >
                {t('common:edit')}
              </SDButton>
              <SDButton
                onClick={handleDelete}
                size={SIZE.mini}
                kind={KIND.secondary}
                overrides={{
                  BaseButton: { style: { backgroundColor: '#D44333', color: '#fff', marginRight: '10px' } },
                }}
              >
                {t('common:delete')}
              </SDButton>
              <SDButton
                onClick={handleAddOffer}
                size={SIZE.mini}
                kind={KIND.secondary}
                className={css({
                  marginRight: '10px',
                })}
              >
                {t('organizationManagement:add_offer_btn')}
              </SDButton>
              {['file_upload', 'ftps', 'api'].includes(selectedProvider.netting_process_type) && (
                <SDButton
                  onClick={handleNetting}
                  size={SIZE.mini}
                  kind={KIND.secondary}
                  className={css({
                    marginRight: '10px',
                  })}
                >
                  {t('organizationManagement:netting_process_btn')}
                </SDButton>
              )}
              {isOptInSmsAvailable && (
                <SDButton
                  onClick={handleOptInSms}
                  size={SIZE.mini}
                  kind={KIND.secondary}
                  className={css({
                    marginRight: '10px',
                  })}
                >
                  {t('organizationManagement:opt_in_sms_btn')}
                </SDButton>
              )}
              <OptInSmsModal />
            </>
          )}
          <SDButton onClick={handleAddProvider} size={SIZE.mini} kind={KIND.secondary}>
            {t('organizationManagement:add_provider_btn')}
          </SDButton>
        </FlexGridItem>
      </FlexGrid>
    </Card>
  )
}

export default Heading
